import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=ff2ee48a&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff2ee48a')) {
      api.createRecord('ff2ee48a', component.options)
    } else {
      api.reload('ff2ee48a', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=ff2ee48a&", function () {
      api.rerender('ff2ee48a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2h5g0CW0B5BR2/JS/cancellationPolicy.vue"
export default component.exports